import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Anexo21Y22RMF2026SGM() {
  return <CategoryPage category="anexo21Y22Rmf2026SGM" pageTitle="Sistema de Gestión de Medición 2026" />;
}

export default Anexo21Y22RMF2026SGM;
